import { Component, ElementRef, EventEmitter, HostBinding, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { OtherService } from 'src/app/Service/other.service';
import { MenuActions, MenuView, buildMenuView, createMenu } from './menu_item.config';
import axios from 'src/app/Service/axios';
declare let $: any;

@Component({
  selector: 'menu_item',
  templateUrl: './menu_itemcomponent.html',
  styleUrls: ['./menu_itemcomponent.css'],
})
export class MenuItemComponent implements OnInit, MenuActions {
  @HostBinding('class') classes = 'MenuItem';
  @Output() modalMenu = new EventEmitter<any>();
  @Output() tripModal = new EventEmitter<boolean>();

  companyName = '';
  fullName = '';
  userInitial = '';
  menu: MenuView[] = [];

  openPath: string[] = [];

  isTaxiReservationOpen = false;
  isCityTaxi = false;

  private permissions: Record<string, boolean> = {};
  private readonly isDesktop: boolean;

  constructor(
    private router: Router,
    private otherService: OtherService,
    private host: ElementRef<HTMLElement>,
    private guard: GurdServiceService,
    deviceService: DeviceDetectorService,
  ) {
    this.isDesktop = deviceService.isDesktop();
  }

  ngOnInit(): void {
    this.companyName = this.readStorage('companyName');
    this.fullName = this.readStorage('FullName');
    this.userInitial = this.fullName?.charAt(0) ?? '';
    this.permissions = JSON.parse(this.readStorage('menu'));
    this.menu = buildMenuView(createMenu(this), (key) => !!this.permissions[key]);
  }

  isOpen(node: MenuView, depth: number): boolean {
    return this.openPath[depth] === node.id;
  }

  toggle(node: MenuView, depth: number): void {
    const parents = this.openPath.slice(0, depth);
    this.openPath = this.isOpen(node, depth) ? parents : [...parents, node.id];
  }

  close(): void {
    this.host.nativeElement.classList.add('d-none');
    document.getElementById('bg-menu')?.classList.add('d-none');
    if (this.isDesktop) $('#test').css('right', '0%');
  }

  logout(): void {
    $.confirm({
      title: 'آیا از خروج حساب کاربری اطمینان دارید؟',
      content: '',
      type: 'red',
      buttons: {
        ok: {
          text: 'تایید',
          btnClass: 'btn-danger',
          keys: ['enter'],
          action: () => {
            this.otherService.removeLocalStorage();
            this.router.navigate(['login']);
            window.location.reload();
          },
        },
        cancel: { text: 'لغو' },
      },
    });
  }

  closeTaxiReservation(): void {
    this.isTaxiReservationOpen = false;
    this.isCityTaxi = false;
  }

  openReport(id: number): void {
    this.openModal('#menuModal');
    this.modalMenu.emit(id);
  }

  openAddVehicle(): void {
    const { bAddGPS: withGps, bAddNGPS: withoutGps } = this.permissions;
    if (withGps && withoutGps) this.openModal('#exampleModal');
    else if (withGps) this.router.navigate(['entryCar/1']);
    else if (withoutGps) this.router.navigate(['entryCar/2']);
  }

  openExcelUploader(): void {
    this.openModal('#exelUploder');
  }

  openModal(selector: string): void {
    $(selector).modal('show');
    $('#map_tooltip').tooltip('hide');
  }

  openTripModal(): void {
    this.tripModal.emit(true);
  }

  openHolidayModal(): void {
    this.otherService.holiday_Status(true);
  }

  openTaxiReservation(isCity: boolean): void {
    this.isCityTaxi = isCity;
    this.isTaxiReservationOpen = true;
  }

  openExternalLink(type: number): void {
    this.otherService.getLink(type);
  }

  async openCompanyInfo(): Promise<void> {
    const response = await axios.post(`GetCompanyInfo?iSystemUser=${this.readStorage('ID')}`);
    window.open(response.data, '_blank');
  }

  private readStorage(key: string): string {
    return this.guard.decrypt(window.localStorage.getItem(key)!);
  }

}
